(() => {
  const parameterNames = {
    sample: 'h2l_sample',
    price: 'h2l_price',
    turnaround: 'h2l_turnaround',
    concern: 'h2l_concern',
  };

  let applying = false;

  function selectedValues(group) {
    return new Set(
      [...document.querySelectorAll(`[data-h2l-filter="${group}"]:checked`)].map((input) => input.value),
    );
  }

  function restoreFromUrl() {
    const params = new URLSearchParams(window.location.search);
    for (const [group, parameter] of Object.entries(parameterNames)) {
      const selected = new Set(params.getAll(parameter));
      document.querySelectorAll(`[data-h2l-filter="${group}"]`).forEach((input) => {
        input.checked = selected.has(input.value);
      });
    }
  }

  function updateUrl() {
    const url = new URL(window.location.href);
    for (const [group, parameter] of Object.entries(parameterNames)) {
      url.searchParams.delete(parameter);
      selectedValues(group).forEach((value) => url.searchParams.append(parameter, value));
    }
    window.history.replaceState({}, '', url);
  }

  function matchesValue(card, group, value) {
    if (group === 'price') {
      const price = Number(card.dataset.h2lPrice);
      if (value === 'under-5000') return price < 5000;
      if (value === '5000-9999') return price >= 5000 && price < 10000;
      if (value === '10000-19999') return price >= 10000 && price < 20000;
      return value === '20000-up' && price >= 20000;
    }
    return value === card.dataset[`h2l${group[0].toUpperCase()}${group.slice(1)}`];
  }

  function matchesSelections(card, selected, candidate = null) {
    return Object.entries(selected).every(([group, values]) => {
      const valuesToMatch = candidate?.group === group ? new Set([candidate.value]) : values;
      return valuesToMatch.size === 0 || [...valuesToMatch].some((value) => matchesValue(card, group, value));
    });
  }

  function updateOptionAvailability(selected) {
    const cards = [...document.querySelectorAll('.h2l-product-card')];
    document.querySelectorAll('[data-h2l-filter]').forEach((input) => {
      const group = input.dataset.h2lFilter;
      const count = cards.filter((card) => matchesSelections(card, selected, { group, value: input.value })).length;
      const item = input.closest('li');
      const text = input.closest('label')?.querySelector('.facet-checkbox__text');

      if (text) {
        text.dataset.h2lLabel ||= text.textContent.trim();
        text.textContent = `${text.dataset.h2lLabel} (${count})`;
      }
      input.disabled = count === 0 && !input.checked;
      if (item) item.hidden = count === 0 && !input.checked;
    });
  }

  function applyFilters({ updateHistory = false } = {}) {
    if (applying) return;
    applying = true;
    const selected = Object.fromEntries(Object.keys(parameterNames).map((group) => [group, selectedValues(group)]));
    let visible = 0;

    document.querySelectorAll('.h2l-product-card').forEach((card) => {
      const matches = matchesSelections(card, selected);
      const item = card.closest('.grid__item');
      if (item) item.hidden = !matches;
      if (matches) visible += 1;
    });

    document.querySelectorAll('[data-product-count], #ProductCountDesktop').forEach((count) => {
      count.textContent = `${visible} ${visible === 1 ? 'test' : 'tests'}`;
    });
    document.querySelectorAll('.h2l-client-facet').forEach((facet) => {
      const count = facet.querySelectorAll('input:checked').length;
      facet.classList.toggle('h2l-client-facet--active', count > 0);
    });
    updateOptionAvailability(selected);
    if (updateHistory) updateUrl();
    applying = false;
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-h2l-filter]')) return;
    document
      .querySelectorAll(`[data-h2l-filter="${event.target.dataset.h2lFilter}"][value="${event.target.value}"]`)
      .forEach((input) => {
        input.checked = event.target.checked;
      });
    applyFilters({ updateHistory: true });
  });

  // Dawn's native facet form listens for input events and would refetch the
  // collection for these client-side controls. Keep those events local so the
  // complete, already-rendered catalogue can be filtered instantly.
  document.addEventListener(
    'input',
    (event) => {
      if (event.target.matches('[data-h2l-filter]')) event.stopPropagation();
    },
    true,
  );

  const observer = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1))) return;
    restoreFromUrl();
    applyFilters();
  });

  function initialise() {
    restoreFromUrl();
    applyFilters();
    const grid = document.getElementById('ProductGridContainer');
    if (grid) observer.observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
})();
